export const SELECTED_ICON_PATH_WHITELIST = [
  /^\/artTools/,
  /^\/changeArt/,
  /^\/editText/,
  /^\/namesAndNumbers\/tools/,
  /^\/searchArt/,
  /^\/selectIcon/,
  /^\/textTools/,
  /^\/uploadTools/,
  /^\/artAndUploadTools/,
  /^\/uploadProgress/,
  /^\/ad\/welcome/,
  /^\/ad\/save\/form/
];

export const ALLOWED_ON_LOAD_PATHS = ['/next/saveConfirmation'];
